import { createClient } from "next-sanity";

const client = createClient({
    projectId: 'eenu4cyl',
    dataset: 'production',
    apiVersion: '2021-10-14',
    useCdn: false
});

export default client;